export const CRM_ADMIN_MODULE_IDS = [
  'crm-dashboard',
  'crm-mi-semana',
  'crm-triaje',
  'crm-catalogos',
  'crm-proyectos',
  'crm-banco-horas',
  'crm-tickets',
  'crm-administracion',
  'crm-acuerdos-facturacion',
  'crm-reportes',
];

export const CRM_LEGACY_ALIAS_MODULES = {
  'crm-catalogos': ['crm-tipos-ticket'],
  'crm-tipos-ticket': ['crm-catalogos'],
  'crm-proyectos': ['crm-tickets'],
  'crm-banco-horas': ['crm-proyectos'],
  'crm-tickets': [],
  'crm-dashboard': ['crm-tickets'],
  'crm-triaje': ['crm-tickets'],
  'crm-administracion': ['crm-reportes', 'crm-acuerdos-facturacion', 'crm-proyectos'],
  'crm-acuerdos-facturacion': ['facturacion', 'crm-tickets'],
  'crm-reportes': ['crm-tickets', 'facturacion'],
};

export const CRM_ORG_MODULE_ALIAS_MAP = {
  'crm-administracion': ['crm-reportes', 'crm-acuerdos-facturacion'],
  'crm-catalogos': ['crm-tipos-ticket'],
  'crm-tipos-ticket': ['crm-catalogos'],
};

/**
 * Alias para decidir si un modulo se OFRECE en las pantallas de roles y
 * usuarios, contra el `custom_modules` de la organizacion.
 *
 * Necesario para permisos finos que no son una pantalla propia y que por lo
 * tanto nunca fueron sembrados en `custom_modules`: sin alias, una org existente
 * con `caja` habilitada no veria el permiso `caja-cierre-completo` y el admin no
 * podria configurarlo. Con el alias, aparece siempre que la org tenga Caja.
 */
export const MODULE_ORG_ALIAS_MAP = {
  ...CRM_ORG_MODULE_ALIAS_MAP,
  'caja-cierre-completo': ['caja'],
  'caja-ver-movimientos': ['caja'],
  'caja-ver-ultimos-movimientos': ['caja'],
  'caja-imprimir-cierre': ['caja'],
  'caja-anular-movimiento': ['caja'],
  'facturacion-venta-administrativa': ['facturacion'],
  'ventas-pos-descuento-autorizar': ['ventas-pos'],
};

export const SYSTEM_ACCESS_MODULE_GROUPS = [
  {
    group: 'Ventas',
    items: [
      { id: 'ventas-pos', label: 'Punto de Venta' },
      { id: 'ventas-historial', label: 'Historial' },
      { id: 'devoluciones', label: 'Devoluciones' },
      { id: 'notas-credito', label: 'Notas de Crédito' },
      { id: 'ventas-profesional', label: 'Ventas Profesional' },
      { id: 'clientes', label: 'Clientes' },
      { id: 'presupuestos', label: 'Presupuestos' },
    ],
  },
  {
    group: 'Inventario',
    items: [
      { id: 'productos', label: 'Productos' },
      { id: 'inventario', label: 'Inventario' },
      { id: 'produccion-registrar', label: 'Produccion' },
      { id: 'pedidos-produccion', label: 'Pedidos Produccion' },
      { id: 'compras', label: 'Compras' },
      { id: 'pedido-sugerido', label: 'Pedido Sugerido' },
      { id: 'proveedores', label: 'Proveedores' },
      { id: 'importar-lista-proveedor', label: 'Importar Lista Proveedor' },
      { id: 'comparador-precios', label: 'Comparador de Precios' },
      { id: 'historial-cambios-masivos', label: 'Cambios Masivos' },
    ],
  },
  {
    group: 'Finanzas',
    items: [
      { id: 'caja', label: 'Caja' },
      { id: 'bancos', label: 'Bancos' },
      { id: 'gastos', label: 'Gastos' },
      { id: 'tesoreria-cobranzas', label: 'Cobros' },
      { id: 'tesoreria-pagos', label: 'Pagos' },
      { id: 'flujo-fondos', label: 'Flujo de Fondos' },
      { id: 'conciliacion-bancaria', label: 'Conciliacion Bancaria' },
      { id: 'conciliacion-ctas-ctes', label: 'Conciliacion Ctas Ctes' },
      { id: 'reportes-inteligentes', label: 'Reportes Inteligentes' },
      { id: 'reportes', label: 'Reportes' },
    ],
  },
  {
    group: 'Sistema',
    items: [
      { id: 'agenda', label: 'CRM Reuniones' },
      { id: 'chatbot', label: 'IA Asistente' },
      { id: 'logistica', label: 'Logistica' },
      { id: 'config-logistica', label: 'Config. Logistica' },
      { id: 'config-sistema-datos', label: 'Sistema y Datos' },
      { id: 'permisos', label: 'Usuarios y Roles' },
      { id: 'logs', label: 'Logs' },
    ],
  },
  {
    group: 'CRM',
    items: [
      { id: 'crm-dashboard', label: 'CRM Mi Panel' },
      { id: 'crm-mi-semana', label: 'CRM Mi Semana' },
      { id: 'crm-triaje', label: 'CRM Triaje' },
      { id: 'crm-catalogos', label: 'CRM Catalogos' },
      { id: 'crm-proyectos', label: 'CRM Proyectos' },
      { id: 'crm-banco-horas', label: 'CRM Banco de Horas' },
      { id: 'crm-tickets', label: 'CRM Tickets' },
      { id: 'crm-administracion', label: 'CRM Administracion' },
      { id: 'crm-acuerdos-facturacion', label: 'CRM Acuerdos y Facturacion' },
      { id: 'crm-reportes', label: 'CRM Reportes' },
    ],
  },
  {
    group: 'Community Manager',
    items: [
      { id: 'comunity-manager-dashboard',    label: 'CM Dashboard' },
      { id: 'comunity-manager-crear',        label: 'CM Crear post' },
      { id: 'comunity-manager-calendario',   label: 'CM Calendario' },
      { id: 'comunity-manager-aprobaciones', label: 'CM Aprobaciones' },
      { id: 'comunity-manager-global',       label: 'CM Vista global' },
    ],
  },
  {
    group: 'Instituto',
    items: [
      { id: 'instituto-grilla', label: 'Instituto - Grilla de Clases' },
      { id: 'instituto-alumnos', label: 'Instituto - Alumnos' },
      { id: 'instituto-profesores', label: 'Instituto - Profesores' },
      { id: 'instituto-cobrar', label: 'Instituto - Cobrar' },
      { id: 'instituto-config', label: 'Instituto - Configuración' },
    ],
  },
];

// Ids del modulo Community Manager, derivados del grupo para no duplicar la
// lista. Se usan para gobernar la ruta anidada /sistema/comunity-manager/*, que
// no tiene un module id unico propio.
export const COMUNITY_MANAGER_MODULE_IDS = (
  SYSTEM_ACCESS_MODULE_GROUPS.find((group) => group.group === 'Community Manager')?.items || []
).map((item) => item.id);

export const SYSTEM_ACCESS_MODULES = SYSTEM_ACCESS_MODULE_GROUPS.flatMap((group) =>
  group.items.map((item) => ({
    ...item,
    category: group.group,
    group: group.group,
  })),
);

export const CRM_DEFAULT_PERMISSION_RESOURCES = [
  {
    module_key: 'crm',
    resource_key: 'catalog_ticket_statuses',
    name: 'Estados de Ticket',
    description: 'CRUD de estados de ticket.',
    resource_type: 'catalog',
    sort_order: 10,
  },
  {
    module_key: 'crm',
    resource_key: 'catalog_ticket_categories',
    name: 'Categorias de Ticket',
    description: 'CRUD de categorias de ticket.',
    resource_type: 'catalog',
    sort_order: 20,
  },
  {
    module_key: 'crm',
    resource_key: 'catalog_project_types',
    name: 'Tipos de Proyecto',
    description: 'CRUD de tipos de proyecto.',
    resource_type: 'catalog',
    sort_order: 30,
  },
  {
    module_key: 'crm',
    resource_key: 'ticket_types',
    name: 'Tipos de Ticket',
    description: 'CRUD de tipos de ticket.',
    resource_type: 'config',
    sort_order: 80,
  },
  {
    module_key: 'crm',
    resource_key: 'ticket_type_tasks',
    name: 'Tareas Predefinidas',
    description: 'CRUD de tareas predefinidas por tipo de ticket.',
    resource_type: 'config',
    sort_order: 90,
  },
  {
    module_key: 'crm',
    resource_key: 'ticket_task_dependencies',
    name: 'Dependencias de Tareas',
    description: 'Secuencia y dependencias de tareas por tipo de ticket.',
    resource_type: 'config',
    sort_order: 100,
  },
  {
    module_key: 'crm',
    resource_key: 'tickets',
    name: 'Tickets CRM',
    description: 'Creacion y seguimiento operativo de tickets.',
    resource_type: 'operation',
    sort_order: 110,
  },
  {
    module_key: 'crm',
    resource_key: 'projects',
    name: 'Proyectos CRM',
    description: 'Creacion y seguimiento de proyectos por cliente.',
    resource_type: 'operation',
    sort_order: 115,
  },
  {
    module_key: 'crm',
    resource_key: 'ticket_runtime_tasks',
    name: 'Tareas de Tickets',
    description: 'Operacion de tareas runtime y secuencia.',
    resource_type: 'operation',
    sort_order: 120,
  },
  {
    module_key: 'crm',
    resource_key: 'meetings',
    name: 'Reuniones CRM',
    description: 'Agenda operativa y cierre de reuniones.',
    resource_type: 'operation',
    sort_order: 130,
  },
  {
    module_key: 'crm',
    resource_key: 'meeting_topics',
    name: 'Temas de Reuniones',
    description: 'Temas y vinculacion con proyectos.',
    resource_type: 'operation',
    sort_order: 140,
  },
  {
    module_key: 'crm',
    resource_key: 'time_entries',
    name: 'Finalizaciones de Tiempo',
    description: 'Registro operativo de horas y minutos invertidos.',
    resource_type: 'operation',
    sort_order: 150,
  },
  {
    module_key: 'crm',
    resource_key: 'user_dashboard',
    name: 'Dashboard de Usuario',
    description: 'Panel operativo personal con tareas, tickets, reuniones y tiempo.',
    resource_type: 'operation',
    sort_order: 160,
  },
  {
    module_key: 'crm',
    resource_key: 'attachments',
    name: 'Adjuntos CRM',
    description: 'Carga y visualizacion de adjuntos internos.',
    resource_type: 'operation',
    sort_order: 180,
  },
  {
    module_key: 'crm',
    resource_key: 'client_services',
    name: 'Servicios Activos',
    description: 'Servicios y entregables activos por cliente.',
    resource_type: 'operation',
    sort_order: 190,
  },
  {
    module_key: 'crm',
    resource_key: 'commercial_agreements',
    name: 'Acuerdos Comerciales',
    description: 'Gestion de acuerdos y condiciones comerciales.',
    resource_type: 'operation',
    sort_order: 200,
  },
  {
    module_key: 'crm',
    resource_key: 'billing_schedules',
    name: 'Programacion de Facturacion',
    description: 'Ciclos y vencimientos generados por acuerdo.',
    resource_type: 'operation',
    sort_order: 210,
  },
  {
    module_key: 'crm',
    resource_key: 'invoices',
    name: 'Facturacion CRM',
    description: 'Comprobantes internos generados desde acuerdos.',
    resource_type: 'operation',
    sort_order: 220,
  },
  {
    module_key: 'crm',
    resource_key: 'reports',
    name: 'Reportes CRM',
    description: 'Reportes de tiempo, proyectos y estado comercial.',
    resource_type: 'report',
    sort_order: 230,
  },
  {
    module_key: 'crm',
    resource_key: 'triage',
    name: 'Vista de Triaje',
    description: 'Priorizacion y asignacion de tickets y tareas sin responsable.',
    resource_type: 'operation',
    sort_order: 170,
  },
];
